import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';

interface CustomerPrivateRouteProps {
  children: React.ReactNode;
}

/**
 * CustomerPrivateRoute - Protects customer portal routes
 * Redirects to /customer/login if not authenticated via customer auth
 */
const CustomerPrivateRoute: React.FC<CustomerPrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useCustomerAuth();
  const location = useLocation();

  if (isLoading) {
    return <Spin size="large" tip="Loading..." fullscreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/customer/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default CustomerPrivateRoute;
